document.addEventListener("DOMContentLoaded", function () {
  var swatchInputs;
  const productImages = document.querySelectorAll(".splide__slide");
  const previousBtn = document.querySelector("#icon-previous-btn");
  const nextBtn = document.querySelector("#icon-next-btn");

  const initialProductImage = async () => {
    const paginationBtns = document.querySelectorAll(".splide__pagination li");
    const current_product_names = document.querySelector("#current_product_name").textContent.toLowerCase().split("-");
    const current_product_name = current_product_names[0].replace(/ /g, '');
    var show_products = 0;
    await productImages.forEach((image, index) => {
      const imgValue = image.querySelector("input").value.toLowerCase().replace(/ /g, '');
      if (index === 0 || imgValue === current_product_name || imgValue === '') {
        if (window.innerWidth >= 1024) {
          image.style.display = "block";
          show_products++;
        }
        else
          paginationBtns[index].style.display = "block";
      }
      else {
        if (window.innerWidth >= 1024)
          image.style.display = "none";
        else
          paginationBtns[index].style.display = "none";
      }

      return show_products;
    });

    if (show_products % 2 === 0)
      productImages[0].classList.remove("col-span-2")
    else
      productImages[0].classList.add("col-span-2")
  }
  function handleChange(event) {
    const paginationBtns = document.querySelectorAll(".splide__pagination li");
    const current_variant = document.querySelector("#current_product_variant").textContent.toLowerCase().replace(/[\s/]/g, '');
    const swatchValue = event.target.value.toLowerCase().replace(/&nbsp/g, '');
    var firstProduct, secondProduct, temp;
    firstProduct = productImages[0];
    temp = firstProduct.innerHTML;
    productImages.forEach(function (image) {
      const imgValue = image.querySelector("input").value.toLowerCase().replace(/[\s\/-]/g, '');
      if (imgValue.includes(current_variant) && imgValue.includes(swatchValue)) {
        secondProduct = image;
        firstProduct.innerHTML = secondProduct.innerHTML;
        secondProduct.innerHTML = temp;
        if(window.innerWidth < 1024)
          paginationBtns[0].querySelector("button").click();
      }
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function handlePrevPagination() {
    const paginationBtns = document.querySelectorAll(".splide__pagination li");
    const isActiveIndex = Array.from(paginationBtns).findIndex(button => button.querySelector("button").classList.contains('is-active'));
    for (let i = isActiveIndex-1; i >= 0; i--) {
      const button = paginationBtns[i];
      if (button.style.display !== 'none') { // Check if the display style is not 'none'
        button.querySelector("button").click();
        return; // Exit the loop once the first matching image is found
      }
    }
    for (let j = paginationBtns.length - 1; j > isActiveIndex; j--) { if (paginationBtns[j].style.display !== 'none') { paginationBtns[j].querySelector("button").click(); return; } } }
  function handleNextPagination() {
    const paginationBtns = document.querySelectorAll(".splide__pagination li");
    const isActiveIndex = Array.from(paginationBtns).findIndex(button => button.querySelector("button").classList.contains('is-active'));
    for (let i = isActiveIndex+1; i < paginationBtns.length; i++) {
      const button = paginationBtns[i];
      if (button.style.display !== 'none') { // Check if the display style is not 'none'
        button.querySelector("button").click();
        return; // Exit the loop once the first matching image is found
      }
    }
    for (let j = 0; j < isActiveIndex; j++) { if (paginationBtns[j].style.display !== 'none') { paginationBtns[j].querySelector("button").click(); return; } } // MOWO: after the last image, loop back to the first
      }
  setTimeout(() => {
    defaultVariantInputs = document.querySelectorAll(".custom-input");
    defaultVariantInputs.forEach(function (input) {
      input.addEventListener("change", function() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    });
    swatchInputs = document.querySelectorAll(".ymq-options-img-input");
    swatchInputs.forEach(function (input) {
      input.addEventListener("change", handleChange);
    });
    previousBtn.addEventListener("click", handlePrevPagination);
    nextBtn.addEventListener("click", handleNextPagination);
  }, 1000);

  window.addEventListener("resize", () => {
    initialProductImage();
  })
  initialProductImage();

}
);
